module.exports = __webpack_public_path__ + "img/pado_hoverd.f7fd20e6.svg";